<template>
    <div class="v-card">
        <div v-if="testimonial.excerpt" class="v-card-header" key="excerpt">
            <div class="v-title">
                <div class="v-title-icon">
                    <img :src="quotesSrc" alt="quote icon" width="30" height="24" loading="lazy">
                </div>
                <h3 class="v-title-text">{{ testimonial.title }}</h3>
            </div>
            <div class="v-content">
                <div class="v-content-text" v-html="testimonial.excerpt"></div>
                <p class="v-author">{{ testimonial.author }}</p>
            </div>
        </div>

        <div v-else key="anonymous">
            <div class="v-title">
                <div class="v-title-icon">
                    <img :src="quotesSrc" alt="quote icon" width="30" height="24" loading="lazy">
                </div>
            </div>
            <div class="v-content-text" v-html="testimonial.full"></div>
        </div>

        <div class="v-card-footer" v-if="testimonial.excerpt && showIndividuleButton">
            <el-button type="text" class="v-readmore" @click.prevent="openFullText">
                <span class="v-readmore-text">Read More</span>
            </el-button>
        </div>

        <el-dialog
                :custom-class="'c-dialog-testimonial' + ' ' + customClass"
                :modal-append-to-body="true"
                :append-to-body="true"
                :visible.sync="readFullText"
                :before-close="handleClose">

            <div class="v-dialog-title" slot="title">
                <strong>“{{ testimonial.title}}”</strong>
            </div>
            <div class="v-full-text-container">
                <div v-html="testimonial.full"></div>
                <p class="v-author">{{ testimonial.author }}</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            testimonial: {
                type: Object,
                required: true
            },

            showIndividuleButton: {
                type: Boolean,
                default: true
            },

            customClass: {
                type: String,
                default: ''
            },

            quotesColor: {
                type: String
            }
        },

        data() {
            return {
                readFullText: false
            }
        },

        computed: {
            fullTextDialogTitle() {
                return `${this.testimonial.title} - ${this.testimonial.author}`
            },

            quotesSrc() {
                if (this.quotesColor) {
                    return `/images/app/quote-testimonial-${this.quotesColor}.svg`
                }
                return '/images/app/quote-testimonial.svg'
            }
        },

        methods: {
            openFullText() {
                this.readFullText = true
                this.$emit('openFullBio', true)
            },

            closeFullText() {
                this.readFullText = false
            },

            handleClose(done) {
                this.$emit('openFullBio', false)
                this.closeFullText()
                done()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-card {
        display: flex;
        flex-flow: row wrap;
    }

    .v-card-header {
        width: 100%;
        flex-basis: 100%;
    }

    .v-title {
        display: flex;
        align-items: flex-start;
        margin-bottom: 1rem;
    }

    .v-title-icon {
        flex-basis: 30px;
        flex-shrink: 0;
        margin-right: 1rem;
    }

    .v-title-text {
        color: #474f59;
        font-size: 1.5rem;
    }

    .v-content-text {
        color: #474f59;
        font-size: inherit;
    }

    .v-author {
        margin-top: 1rem;
        color: #474f59;
    }

    .v-card-footer {
        display: flex;
        align-items: flex-end;
        margin-top: 1rem;
    }

    .v-readmore-text {
        display: flex;
        align-items: center;
        color: #474f59;
        font-weight: 600;
        font-size: 1rem;
        text-transform: uppercase;
        transition: transform .3s;

        &::before {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            flex-basis: 20px;
            height: 20px;
            flex-shrink: 0;
            margin-right: .5rem;
            border-radius: 50%;
            color: #fff;
            background-color: #24c6dc;
            content: '\f0da';
            font-family: 'FontAwesome';
            font-size: 12px;
        }

        &:hover {
            transform: translateX(5px);
        }
    }

    .v-dialog-title {
        font-size: 1.3rem;
    }

    .v-full-text-container {
        font-size: 1rem;
        color: #474f59;
        word-break: break-word;

        > div {
            font-size: inherit;
        }
    }
</style>

<style lang="scss">
    .c-dialog-testimonial {
        width: 90%;

        .el-dialog__body {
            padding: 1rem 2rem 2rem;

            p {
                + p {
                    margin-top: 1rem;
                }
            }
        }
    }

    .gh-home-dialog-testimonial {
         .el-dialog__body {
             .v-full-text-container {
                 font-size: 1.1rem;
             }
         }
    }

    @media screen and (min-width: '768px') {
        .c-dialog-testimonial {
            width: 50%;

            .v-author {
                display: inline-block;
            }
        }
    }
</style>
